import {
	LOG,
	SET_ITEMS,
	SET_ITEMS_AAXML,
	GO_TO_PREVIOUS_ITEM,
	GO_TO_NEXT_ITEM,
	GO_TO_ITEM,
	RECOVER_SAVED_STATE,
	SHOW_RESULTS,
	RESTART_EXERCISE,
	START_RECORDING,
	STOP_RECORDING,
	SET_EXERCISE_READY,
	ANSWER_QUESTION,
	SET_WORDS_PER_MINUTE,
	SET_WORDS_RECOGNISED,
	SET_ITEM_MARKED_TEXT,
	SET_AUDIO_PREFIX,
	SET_AUDIO_ENABLED,
	SET_UPLOAD_URLS,
	SET_CHUNK,
	GET_CHUNK,
	DISABLE_RECORDING,
	ENABLE_RECORDING,
} from '../actions/types';

// Return object from function to avoid data sharing between instances
const INITIAL_STATE = () => ({
	log: [],
	items: [],
	itemsAAXML: [],
	currentItem: 0,
	resultsVisible: false,
	recording: false,
	exerciseReady: false,
	questionsAnswered: [],
	wordsPerMinute: null,
	wordsRecognisedPercent: null,
	wordsRecognised: null,
	totalWords: null,
	itemsMarkedText: [],
	audioPrefix: null,
	audioEnabled: null,
	remoteURL: null,
	s3SignedUrl: null,
	readyForNextChunk: false,
	chunks: [],
	aaPlayer: null,
	recordingDisabled: false
});

export default function (state = INITIAL_STATE(), action) {
	// console.log(action.type);
	switch (action.type) {
		case SET_AUDIO_ENABLED: {
			const newState = { ...state };
			newState.audioEnabled = action.payload;
			return newState;
		}

		case SET_AUDIO_PREFIX: {
			const newState = { ...state };
			newState.audioPrefix = action.payload;
			return newState;
		}

		case SET_ITEM_MARKED_TEXT: {
			const newState = { ...state };
			const { currentItem, itemsMarkedText } = newState;
			itemsMarkedText[currentItem] = action.payload;
			return newState;
		}

		case SET_WORDS_RECOGNISED: {
			const newState = { ...state };
			newState.wordsRecognisedPercent = action.payload.wordsRecognisedPercent;
			newState.wordsRecognised = action.payload.wordsRecognised;
			newState.totalWords = action.payload.totalWords;
			return newState;
		}

		case SET_WORDS_PER_MINUTE: {
			const newState = { ...state };
			newState.wordsPerMinute = action.payload;
			return newState;
		}

		case ANSWER_QUESTION: {
			const newState = { ...state };
			const { currentItem } = newState;
			newState.questionsAnswered = [...(newState.questionsAnswered || [])];
			newState.questionsAnswered[currentItem] = true;
			return newState;
		}

		case SET_EXERCISE_READY: {
			const newState = { ...state };
			newState.exerciseReady = true;
			return newState;
		}

		case SET_ITEMS: {
			const newState = { ...state };
			newState.items = action.payload;
			return newState;
		}

		case SET_ITEMS_AAXML: {
			const newState = { ...state };
			newState.itemsAAXML = action.payload;
			return newState;
		}

		case GO_TO_PREVIOUS_ITEM: {
			const newState = { ...state };
			if (newState.resultsVisible) {
				newState.resultsVisible = false;
				newState.currentItem = newState.items.length - 1;
			} else {
				newState.currentItem--;
			}
			return newState;
		}

		case GO_TO_NEXT_ITEM: {
			const newState = { ...state };
			newState.currentItem++;
			return newState;
		}

		case GO_TO_ITEM: {
			const newState = { ...state };
			newState.currentItem = action.payload;
			newState.resultsVisible = false;
			return newState;
		}

		case SHOW_RESULTS: {
			const newState = { ...state };
			newState.resultsVisible = true;
			newState.currentItem = null;
			return newState;
		}

		case RECOVER_SAVED_STATE: {
			const newState = { ...state };
			newState.currentItem = action.payload.currentItem;
			newState.resultsVisible = action.payload.resultsVisible;
			newState.questionsAnswered = action.payload.questionsAnswered;
			newState.wordsPerMinute = action.payload.wordsPerMinute;
			newState.wordsRecognisedPercent = action.payload.wordsRecognisedPercent;
			newState.itemsMarkedText = action.payload.itemsMarkedText;
			return newState;
		}

		case RESTART_EXERCISE: {
			return {
				...INITIAL_STATE(),
				itemsAAXML: state.itemsAAXML,
				items: state.items,
				exerciseReady: true,
				questionsAnswered: [],
				itemsMarkedText: []
			};
		}

		case START_RECORDING: {
			const newState = { ...state };
			newState.recording = true;
			newState.chunks = [];
			return newState;
		}

		case STOP_RECORDING: {
			const newState = { ...state };
			newState.recording = false;
			return newState;
		}

		case LOG: {
			const newState = { ...state };
			newState.log = [...state.log, action.payload];
			return newState;
		}

		case SET_UPLOAD_URLS: {
			// console.log('save URLs and set readyForNextChunk to TRUE so that we start to request chunks');
			const newState = { ...state };
			newState.remoteUrl = action.payload.remoteUrl;
			newState.s3SignedUrl = action.payload.s3SignedUrl;
			newState.readyForNextChunk = true;
			return newState;
		}

		case GET_CHUNK: {
			// console.log('setting readyForNextChunk to FALSE');
			const newState = { ...state };
			newState.readyForNextChunk = false;
			return newState;
		}

		case SET_CHUNK: {
			// console.log('setting readyForNextChunk to TRUE');
			const newState = { ...state };
			newState.chunks.push({
				chunk: action.payload.chunk,
			});
			if (!action.payload.lastChunk) newState.readyForNextChunk = true;
			return newState;
		}

		case ENABLE_RECORDING: {
			const newState = { ...state };
			newState.recordingDisabled = false;
			return newState;
		}

		case DISABLE_RECORDING: {
			const newState = { ...state };
			newState.recordingDisabled = true;
			return newState;
		}

		default:
			return state;
	}
}
